import styled from 'styled-components'

import { myTheme } from '../../styles'

const { fontSize, fontWeight, breakpoint } = myTheme

export const H1 = styled.h1`
  font-size: ${fontSize.two};
  margin-bottom: 0;

  @media screen and (min-width: ${breakpoint.medium}) {
    font-size: ${fontSize.one};
    margin-bottom: 0;
  }
`
export const H2 = styled.h2`
  font-size: ${fontSize.two};
  margin-bottom: 0;
`
export const H3 = styled.h3`
  font-size: ${fontSize.three};
  font-weight: ${fontWeight.five};
  margin-bottom: 0;
`
export const H4 = styled.h4`
  font-size: ${fontSize.four};
  font-weight: ${fontWeight.five};
  margin-bottom: 0;
`
export const H5 = styled.h5`
  font-size: ${fontSize.five};
  margin-bottom: 0;
`
export const H6 = styled.h6`
  font-size: ${fontSize.six};
  margin-bottom: 0;
`

export const Headline = styled.div`
  font-size: ${fontSize.one};
  margin-bottom: 0;

  @media screen and (min-width: ${breakpoint.medium}) {
    font-size: ${fontSize.headline};
    margin-bottom: 0;
  }
`
export const Subheadline = styled.div`
  font-size: ${fontSize.two};
  margin-bottom: 0;

  @media screen and (min-width: ${breakpoint.medium}) {
    font-size: ${fontSize.subheadline};
    margin-bottom: 0;
  }
`



// WEBPACK FOOTER //
// ./src/components/typography/headings.js